import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';

@Injectable()
export class AuthGuard {

    constructor(private router: Router, private cookie: CookieService) { }

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {

        const token = this.cookie.get('AuthToken');

        if (token) {
            this.router.navigate(['/pages/dashboard']);
            return false
        }

        return true;
    }

}
